export default function TabNav({ tabs, current, onChange }) {
  return (
    <nav class="tab-nav">
      {tabs.map(tab => (
        <button
          key={tab.id}
          type="button"
          class={`tab-btn ${current === tab.id ? 'tab-btn-active' : ''}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}
